const DEFAULT_BANNER_URL =
  "https://static-api.nkstatic.com/appdocs/4/assets/opendata/bbd8e1412f656b91db7df7aabbc1598b_TeamsBannerDeafult.png";
const DEFAULT_AVATAR_URL =
  "https://static-api.nkstatic.com/appdocs/4/assets/opendata/db32af61df5646951a18c60fe0013a31_ProfileAvatar01.png";

export { DEFAULT_AVATAR_URL, DEFAULT_BANNER_URL };
